const GOOGLE_CLIENT_ID =
  "260935068115-opv140318u68ce7odt1j29gth2p4mrlg.apps.googleusercontent.com";

let _scriptPromise = null;

function loadGsiScript() {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (_scriptPromise) return _scriptPromise;

  _scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Failed to load Google Identity script"));
    document.head.appendChild(script);
  });

  return _scriptPromise;
}

// Google ID tokens (from the One Tap / GSI button credential flow) carry no
// backend-refreshable refresh token, so renewal has to happen client-side:
// this silently re-prompts Google for a fresh ID token using the browser's
// existing Google session (no visible UI if the session is still valid).
// Rejects if Google can't do it without user interaction — callers should
// treat that as "log the user out", not retry.
async function silentRefresh() {
  await loadGsiScript();

  return new Promise((resolve, reject) => {
    let settled = false;
    // Safety net: GSI's prompt() moment notification isn't guaranteed to fire
    // for every outcome (e.g. the account chooser sitting open, unclicked).
    // Without this, an unresolved promise here hangs the router.beforeEach
    // guard that awaits this call, leaving the whole app blank indefinitely.
    const timeoutId = setTimeout(() => {
      if (settled) return;
      settled = true;
      window.google.accounts.id.cancel();
      reject(new Error("Google silent refresh timed out"));
    }, 10000);

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: response => {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        resolve(response.credential);
      },
      cancel_on_tap_outside: false
    });

    window.google.accounts.id.prompt(notification => {
      if (settled) return;
      if (
        notification.isNotDisplayed?.() ||
        notification.isSkippedMoment?.() ||
        notification.isDismissedMoment?.()
      ) {
        settled = true;
        clearTimeout(timeoutId);
        reject(new Error("Google silent refresh unavailable"));
      }
    });
  });
}

export const googleAuthService = { silentRefresh };
